<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 36 31"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.6862 31L29.6413 20.479H8.59232L17.8539 4.4162L25.8201 18.2709H28.3676L17.8539 0L4.77111 22.6871H28.3676L31.865 28.7919H3.82121L6.04485 24.9169H3.49738L0 31H35.6862Z"
     :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.8533 8.85449C14.4423 14.7644 11.0313 20.6527 7.64185 26.5626H10.1893L12.413 22.6876H23.2721L25.4957 26.5626H28.0432C24.6538 20.6527 21.2427 14.7644 17.8533 8.85449ZM21.9984 20.4795H13.6867L17.8533 13.2707L21.9984 20.4795Z"
      :fill="color"
    />
  </svg>
</template>

<script>

export default {
  props: {
    width: { type: [Number, String], default: 18 },
    height: { type: [Number, String], default: 20 },
    color: { type: String, default: '#C8C8C8' },
  },
};
</script>
